module.exports = __webpack_public_path__ + "static/img/telegram-floating-button.0b471a8.png";